import { Flex } from "antd";
import { FC, useMemo, useState } from "react";
import {
    AssortmentTaskType,
    Market,
    SubtaskFinGroupPhotosPayload,
    TaskAssortmentMatrix,
} from "tm-shared/types";

import { CustomTaskFromTaskButton } from "../components/CustomTaskFromTaskButton";
import { TaskViewModal } from "../TaskViewModal";
import { AssortmentMatrixSubtaskView } from "./ProductsMatrixSubtaskView";
import { StepsSection } from "./StepsSection";

interface AssortmentMatrixViewModalProps {
    task: TaskAssortmentMatrix;
    market: Market;
    onClose: () => void;
}

export const AssortmentMatrixViewModal: FC<AssortmentMatrixViewModalProps> = ({
    task,
    market,
    onClose,
}) => {
    const { payload, context, completedAt, name, info } = task;

    const [step, setStep] = useState(0);

    const taskImages = useMemo(() => {
        if (!payload) return [];

        const photoTask = Object.values(payload).find(
            (item): item is SubtaskFinGroupPhotosPayload =>
                item.type === AssortmentTaskType.FinGroupPhotos,
        );

        if (!photoTask?.tasks) return [];

        return Object.values(photoTask.tasks).flatMap(
            (task) => task.photos ?? [],
        );
    }, [payload]);

    if (!payload || !completedAt) return null;

    const { subtasks } = context;
    const currentSubtask = subtasks[step];
    const currentPayload = payload[currentSubtask.subtaskId];

    return (
        <TaskViewModal title={name} onClose={onClose} taskInfo={info}>
            <Flex vertical gap={16}>
                <CustomTaskFromTaskButton
                    task={task}
                    market={market}
                    images={taskImages}
                />

                <StepsSection
                    subtasks={subtasks}
                    currentStep={step}
                    onStepChange={setStep}
                />

                <AssortmentMatrixSubtaskView
                    subtask={currentSubtask}
                    payload={currentPayload}
                />
            </Flex>
        </TaskViewModal>
    );
};
